import type { HTMLAttributes, PropsWithChildren } from 'react';

type CardProps = HTMLAttributes<HTMLDivElement> & {
    header?: string;
}

export function Card({ children, className = '', header, ...props }: PropsWithChildren<CardProps>) {
    return (
        <div className={`m-5 bg-background text-foreground p-6 outline outline-muted rounded shadow ${className}`} {...props}>
            {!!header && <h2 className="text-xl mb-2 font-semibold text-foreground text-center">{header}</h2>}
            {children}
        </div>
    );
}